import { render, staticRenderFns } from "./AreasMap.vue?vue&type=template&id=345322d8&scoped=true"
import script from "./AreasMap.vue?vue&type=script&lang=js"
export * from "./AreasMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345322d8",
  null
  
)

export default component.exports